/**
 * Робота із записом поза його карткою (KAN-11, LST-23): що доступно й з чим працює панель
 * (`work-panel.tsx`, `work-panel-body.tsx`). Окремо від панелі: список вантажить лише це в першому
 * екрані, панель — лінивим чанком на клік.
 *
 * Доступ — як у картці: запис виконаної — лише з рівнем `edit` на поля режиму (`logAvailable`, fail
 * closed), задача — з правом створювати задачі; обидва — лише на сутності з поведінкою активностей.
 * Немає доступу — немає пункту меню (П-05).
 */
import type { AppMeta, MetaEntity } from '@clientline/contracts';
import { entityOf } from '../../platform/meta.ts';
import { TASK_ENTITY } from '../today/source.ts';
import { LOG_HOST_BEHAVIOR, logAvailable } from './outcome/types.ts';

export type WorkKind = 'log' | 'plan';

/** Запис, з яким працюють: назва — тема за замовчуванням і контекст панелі. */
export interface WorkHost {
  entity: string;
  id: string;
  title: string;
}

export interface WorkPanelState {
  kind: WorkKind;
  host: WorkHost;
}

export interface WorkPanelProps {
  panel: WorkPanelState;
  /** Збережено (запис, крок чи задача): перечитати запис у власника. */
  onDone: (host: WorkHost) => void;
  /** Панель закрилась (збереження, «Скасувати», `Esc`): фокус — назад на запис. */
  onClose: () => void;
}

/** Які дії доступні на записах сутності `entity`. */
export function workAccess(
  meta: AppMeta | undefined,
  entity: MetaEntity,
): Record<WorkKind, boolean> {
  const activity = meta ? entityOf(meta, TASK_ENTITY) : undefined;
  const host = entity.key !== TASK_ENTITY && LOG_HOST_BEHAVIOR in (entity.behaviors ?? {});
  return {
    log: host && logAvailable(activity, entity),
    plan: host && activity?.canCreate === true,
  };
}
